var stripeResponseHandler = function(status, response) {
    var form = $('#payment-form');
 
    // Any validation errors?
    if (response.error) {
        // Show the user what they did wrong
        form.find('.payment-errors').text(response.error.message);
 
        // Make the submit clickable again
        form.find('button').prop('disabled', false);
    } else {
        // Otherwise, we're good to go! Submit the form.
 
        // Insert the unique token into the form
        $('<input>', {
            'type': 'hidden',
            'name': 'stripeToken',
            'value': response.id
        }).appendTo(form);
 
        // Call the native submit method on the form
        // to keep the submission from being canceled
        form.get(0).submit();
    }
};

(function($) {

// prettyPhoto
	jQuery(document).ready(function(){
		jQuery('a[data-gal]').each(function() {
			jQuery(this).attr('rel', jQuery(this).data('gal'));
		});  	
		jQuery("a[data-rel^='prettyPhoto']").prettyPhoto({animationSpeed:'slow',theme:'light_square',slideshow:false,overlay_gallery: false,social_tools:false,deeplinking:false});
	}); 

    $.fn.stars = function() {
        return $(this).each(function() {
            // Get the value
            var val = parseFloat($(this).html());
            // Make sure that the value is in 0 - 5 range, multiply to get width
            var size = Math.max(0, (Math.min(5, val))) * 16;
            // Create stars holder
            var $span = $('<span />').width(size);
            // Replace the numerical value with stars
            $(this).html($span);
        });
    }

    $("#payment-form").submit(function(event) {
        
        var $form = $(this);
        // disable the submit button to prevent repeated clicks
        $('.submit-button').attr("disabled", "disabled");
        
        // createToken returns immediately - the supplied callback submits the form if there are no errors
        Stripe.createToken($form, stripeResponseHandler);
            return false; // submit from callback
        });
		
})(jQuery);

jQuery('.hstar').stars();

jQuery('document').ready(function(){
    jQuery('#selectAll').click(function() {
       if (this.checked) {
           jQuery(':checkbox').each(function() {
               this.checked = true;                        
           });
       } else {
          jQuery(':checkbox').each(function() {
               this.checked = false;                        
           });
       } 
    });
});
jQuery(document).ready(function($) {
	//var input = $(".pro_edit_input_wrap").find('input');
    $(".pro_edit_input_wrap input:text").focus(function(){
        var last_active = $(this).parent().parent().find('.active');
        var current_input = $(this).parent();
        $(last_active).removeClass("active");
        $(current_input).addClass("active");
        
    })
	
	$(".pro_edit_input_wrap select").focus(function(){
        var last_active = $(this).parent().parent().find('.active');
        var current_input = $(this).parent();
        $(last_active).removeClass("active");
        $(current_input).addClass("active");
        
    })
	
	$(".pro_edit_input_wrap input:checkbox").focus(function(){
        var last_active = $(this).parent().parent().parent().find('.active');
		console.log('test'+last_active);
        var current_input = $(this).parent().parent();
        $(last_active).removeClass("active");
        $(current_input).addClass("active");
        
    })
});
jQuery(document).ready(function() {
        $('.info_tooltip').tooltipster({
			side: 'right',
		});
		
		$('.confirm-share-landlord').click(function(){
			return confirm("Are you sure you want to send this file to your landlord?");
		});
		
		$('.confirm-del').click(function(){
			return confirm("Are you sure you want to delete this file?");
        });
        
        $('.file-share-tenants').click(function(){
			return confirm("Are you sure you want to share this file with your tenant's?");
        });
        
        $('#resolve_issue').submit(function() {
            var c = confirm("Are you sure you want to mark this issue as resolved?");
            return c; //you can just return c because it will be true or false
        });
        $('#reopen_issue').submit(function() {
            var c = confirm("Are you sure you want to reopen this issue?");
            return c; //you can just return c because it will be true or false
        });

        $('.confirm-contractor-del').click(function(){
			return confirm("Are you sure you want to remove this contractor?");
        });
});

jQuery(document).ready(function() {
    jQuery('.signup_form').validate({
    rules: {
        first_name: "required",  
        last_name: "required",
        gender:"required",
        password:"required",
        confpassword:"required",
        email: {
        required: true,
        email: true
        },
    },
    
    highlight: function(element, errorClass, validClass) { 
        jQuery(element).nextAll('.form-control-feedback').show().removeClass('glyphicon-ok').addClass('glyphicon-remove');
        jQuery(element).addClass(errorClass).removeClass(validClass);
        jQuery(element).closest('.form-group').removeClass('has-success').addClass('has-error');
    },
    success: function(element) {
        jQuery(element).nextAll('.form-control-feedback').show().removeClass('glyphicon-remove').addClass('glyphicon-ok');
        element.closest('.form-group').removeClass('has-error').addClass('has-success');
        jQuery(element).remove();
    }
    });
});

function confirmFileShare(id){
    //e.preventDefault();
    if (confirm("Are you sure you want to share this file with your tenants?")){
        $(id).submit();
    }
}
$( function() {
    $( "#contract_end_date" ).datepicker();
    $( "#assign-contractor" ).on('click', function(e){
        var contractor_id = $('input[name="contractor_id"]').is(':checked') ;  
        if(!contractor_id){
            e.preventDefault();
            alert('Please choose a contractor.');
        }
    });

    $('#add-issue-next').on('click', function(){
        if(!$('input[name="issue-type"]').is(':checked')){
            alert('Please Choose an Issue Type.');
            return false;
        }
        $('.issue-step-1').hide();
        $('.issue-step-2').show();
    });

    $('#add-issue-back').on('click', function(){
        $('.issue-step-2').hide();
        $('.issue-step-1').show();
    });

});

$(".tenant_docs").find('.btn-danger').click(function(){
    alert("Please contact your landlord to request this document.");
    return false;
});

$(function () {
    $('[data-toggle="popover"]').popover()
});